import type { PlatformFile } from '@healthshare/shared/platform/file'

/**
 * Wraps a browser File (or Blob) as a PlatformFile.
 *
 * A `File` already carries name/size/type and has `arrayBuffer()`, so this is
 * almost the identity function -- its job is to stop `File` from appearing in the
 * signatures of core code that has to run under React Native too.
 */
export function webFile(file: File): PlatformFile {
  return {
    name: file.name,
    size: file.size,
    type: file.type,
    read: () => file.arrayBuffer(),
  }
}

/**
 * Wraps a Blob that has no name of its own (e.g. a generated PDF).
 *
 * `File` extends `Blob`, so prefer webFile() when you actually have a File and
 * want to keep its real name.
 */
export function webBlobFile(blob: Blob, name: string, type = blob.type): PlatformFile {
  return {
    name,
    size: blob.size,
    type,
    read: () => blob.arrayBuffer(),
  }
}
